import { defineMessages } from 'react-intl';

export default defineMessages({
    next: {
        id: 'premier.policychange.common.views.quotePage.Next',
        defaultMessage: 'Next'
    },
    finish: {
        id: 'premier.policychange.common.views.quotePage.Finish',
        defaultMessage: 'Finish'
    },
    quote: {
        id: 'premier.policychange.common.views.quotePage.Quote',
        defaultMessage: 'Quote'
    }
});
